const hasPermission = (userPermission, requiredPermission) => {
  return userPermission.some(up => requiredPermission.includes(up));
};

export default hasPermission;
